import { Disease } from '../../../ana-toolbox'
import { DiseaseType } from '../../../ana-toolbox'

/*
 * Hardcoded list of diseases, the disease name is the key
 * for the translation.
 */
const diseases: Disease[] = [
  {
    type: DiseaseType.INFECTIOUS,
    name: 'hiv',
  },
  {
    type: DiseaseType.INFECTIOUS,
    name: 'tuberculosis',
  },
  {
    type: DiseaseType.INFECTIOUS,
    name: 'hepatitis_a',
  },
  {
    type: DiseaseType.INFECTIOUS,
    name: 'hepatitis_b',
  },
  {
    type: DiseaseType.INFECTIOUS,
    name: 'hepatitis_c',
  },
  {
    type: DiseaseType.HEART,
    name: 'heart_attack',
  },
  {
    type: DiseaseType.HEART,
    name: 'heart_failure',
  },
  {
    type: DiseaseType.HEART,
    name: 'arrhythmia_atrial_fibrillation',
  },
  {
    type: DiseaseType.HEART,
    name: 'heart_defects',
  },
  {
    type: DiseaseType.HEART,
    name: 'chest_pain_angina_pectoris',
  },
  {
    type: DiseaseType.HEART,
    name: 'pacemaker',
  },
  {
    type: DiseaseType.HEART,
    name: 'myocarditis',
  },
  {
    type: DiseaseType.HEART,
    name: 'heart_valve_disease',
  },
  {
    type: DiseaseType.HEART,
    name: 'heart_valve_replacement',
  },
  {
    type: DiseaseType.HEART,
    name: 'endocarditis',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'stroke',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'chd_coronary_heart_disease',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'high_blood_pressure',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'glaucoma',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'low_blood_pressure',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'pad',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'varicose_veins_chronic_venous_insufficiency',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'leg_vein_thrombosis',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'circulatory_disorders',
  },
  {
    type: DiseaseType.CIRCULATORY_VASCULAR,
    name: 'bleeding_disorders',
  },
  {
    type: DiseaseType.LUNG,
    name: 'asthma',
  },
  {
    type: DiseaseType.LUNG,
    name: 'copd',
  },
  {
    type: DiseaseType.LUNG,
    name: 'chronic_bronchitis',
  },
  {
    type: DiseaseType.LUNG,
    name: 'pulmonary_fibrosis',
  },
  {
    type: DiseaseType.BONE_MUSCULAR_COGNITIVE_TISSUE,
    name: 'autoimmune_disease',
  },
  {
    type: DiseaseType.BONE_MUSCULAR_COGNITIVE_TISSUE,
    name: 'osteoporosis',
  },
  {
    type: DiseaseType.BONE_MUSCULAR_COGNITIVE_TISSUE,
    name: 'arthrosis',
  },
  {
    type: DiseaseType.BONE_MUSCULAR_COGNITIVE_TISSUE,
    name: 'increased_bone_fractures',
  },
  {
    type: DiseaseType.BONE_MUSCULAR_COGNITIVE_TISSUE,
    name: 'disc_prolapse',
  },
  {
    type: DiseaseType.CANCER,
    name: 'pancreatic_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'breast_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'colon_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'uterine_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'skin_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'liver_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'leukemia',
  },
  {
    type: DiseaseType.CANCER,
    name: 'lung_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'stomach_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'prostate_cancer',
  },
  {
    type: DiseaseType.CANCER,
    name: 'salivary_gland_cancer',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'type_i_diabetes',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'type_ii_diabetes',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'hyperthyroidism',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'hypothyroidism',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'thyroid_enlargement_goiter',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'lipid_metabolism_disorder',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'obesity',
  },
  {
    type: DiseaseType.METABOLIC,
    name: 'gout',
  },
  {
    type: DiseaseType.GASTRIC_INTESTINAL,
    name: 'gastritis',
  },
  {
    type: DiseaseType.GASTRIC_INTESTINAL,
    name: 'stomach_ulcer',
  },
  {
    type: DiseaseType.GASTRIC_INTESTINAL,
    name: 'chronic_inflammatory_bowel_disease',
  },
  {
    type: DiseaseType.GASTRIC_INTESTINAL,
    name: 'reflux_disease',
  },
  {
    type: DiseaseType.LIVER_BILIARY,
    name: 'liver_cirrhosis',
  },
  {
    type: DiseaseType.LIVER_BILIARY,
    name: 'fatty_liver',
  },
  {
    type: DiseaseType.LIVER_BILIARY,
    name: 'hepatitis',
  },
  {
    type: DiseaseType.LIVER_BILIARY,
    name: 'gallstones',
  },
  {
    type: DiseaseType.KIDNEY_URINARY_TRACT,
    name: 'kidney_stones',
  },
  {
    type: DiseaseType.KIDNEY_URINARY_TRACT,
    name: 'bladder_stones',
  },
  {
    type: DiseaseType.KIDNEY_URINARY_TRACT,
    name: 'inflammation_of_the_kidneys',
  },
  {
    type: DiseaseType.KIDNEY_URINARY_TRACT,
    name: 'chronic_renal_failure',
  },
  {
    type: DiseaseType.PSYCHOLOGICAL,
    name: 'dementia',
  },
  {
    type: DiseaseType.PSYCHOLOGICAL,
    name: 'depression',
  },
  {
    type: DiseaseType.PSYCHOLOGICAL,
    name: 'anxiety_disorder',
  },
  {
    type: DiseaseType.PSYCHOLOGICAL,
    name: 'parkinson',
  },
  {
    type: DiseaseType.PSYCHOLOGICAL,
    name: 'multiple_sclerosis',
  },
  {
    type: DiseaseType.PSYCHOLOGICAL,
    name: 'migraine',
  },
  {
    type: DiseaseType.PSYCHOLOGICAL,
    name: 'nerve_disease',
  },
  {
    type: DiseaseType.MEDICATION_ALLERGIES,
    name: 'penicillin',
  },
  {
    type: DiseaseType.MEDICATION_ALLERGIES,
    name: 'diclofenac',
  },
  {
    type: DiseaseType.MEDICATION_ALLERGIES,
    name: 'acetylsalicylic_acid',
  },
  {
    type: DiseaseType.MEDICATION_ALLERGIES,
    name: 'contrast_media',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'pollen',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'house_dust',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'animal_hair',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'metals',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'food',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'band_aid',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'mold',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'latex',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'insect_venom',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'iodine',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'budget',
  },
  {
    type: DiseaseType.OTHER_ALLERGIES,
    name: 'plastic',
  },
  {
    type: DiseaseType.OTHER,
    name: 'epilepsy',
  },
  {
    type: DiseaseType.OTHER,
    name: 'fainting_spells',
  },
]

export const diseasesByType: Record<DiseaseType, Disease[]> = diseases.reduce<Record<DiseaseType, Disease[]>>(
  (grouped, disease) => {
    const previousDiseasesForCurrentType = grouped[disease.type] || []

    return {
      ...grouped,
      [disease.type]: [...previousDiseasesForCurrentType, disease],
    }
  },
  {
    INFECTIOUS: [],
    HEART: [],
    CIRCULATORY_VASCULAR: [],
    LUNG: [],
    BONE_MUSCULAR_COGNITIVE_TISSUE: [],
    CANCER: [],
    METABOLIC: [],
    GASTRIC_INTESTINAL: [],
    LIVER_BILIARY: [],
    KIDNEY_URINARY_TRACT: [],
    PSYCHOLOGICAL: [],
    MEDICATION_ALLERGIES: [],
    OTHER_ALLERGIES: [],
    SURGERY: [],
    OTHER: [],
  }
)

export const diseasesForPage1 = [
  ...diseasesByType.PSYCHOLOGICAL,
  ...diseasesByType.LUNG,
  ...diseasesByType.METABOLIC,
  ...diseasesByType.BONE_MUSCULAR_COGNITIVE_TISSUE,
]

export const diseasesForPage2 = [
  ...diseasesByType.CIRCULATORY_VASCULAR,
  ...diseasesByType.GASTRIC_INTESTINAL,
  ...diseasesByType.HEART,
  ...diseasesByType.CANCER,
]

export const diseasesForPage3 = [
  ...diseasesByType.KIDNEY_URINARY_TRACT,
  ...diseasesByType.LIVER_BILIARY,
  ...diseasesByType.INFECTIOUS,
  ...diseasesByType.OTHER,
]

export default diseases
